<template>
    <div>
        <div class="inner-box">
            <ul class='header-bar-ul'>
                <li>
                    <span>Chrome浏览器</span>
                    <a :href="$static_url+'/public_files/download/49.0.2623.112_chrome_installer.exe'">本地49版适用XP</a>
                    <a :href="$static_url+'/public_files/download/72.0.3626.121_chrome_installer.exe'">本地72版32位</a>
                    <a :href="$static_url+'/public_files/download/72.0.3626.121_chrome_installer_x64.exe'">本地72版64位</a>
                </li>
                
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'download',
        data() {
            return {
                
            }
        },
        props: {
            
        },
        created() {
            
        },
        methods: {
            
        }
    }
</script>

<style scoped>

    a {
        text-decoration: none;
        color: inherit;
    }

    a:visited {
        text-decoration: none;
    }

    a:hover {
        text-decoration: none;
        color:inherit;
    }
    li{
        list-style: none;
        color:#000;
        font-size: 20px;
    }
    li>a{
        margin:0 20px;
        color:blue;
        font-size: 14px;
    }
    .inner-box{
        min-height: 500px;
        padding: 50px 30px;
    }


</style>